module.exports = __webpack_public_path__ + "assets/f37f976d7c3b3e56ee037d8f1e2d0580.png";